import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const AboutMeApi = {
  updateAboutMe: async (userId, aboutMe) => {
    try {
      const response = await axiosInstance.post(Configs.updateAboutMeEp, {
        user_id: userId,
        about_me: aboutMe,
      });

      return response.data.status === "success";
    } catch (error) {
      console.error("Error updating About Me:", error);
      return false;
    }
  },
};

export default AboutMeApi;
